export default __webpack_public_path__ + "static/media/twint-icon-qr_code.b7860974.svg";